import { codePropsSchema } from '../component-catalog.js';
export const codeDefinition = {
    type: 'Code',
    category: 'content',
    propsSchema: codePropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Syntax-highlighted code block. Props: code (required), language?, showLineNumbers?.',
};
//# sourceMappingURL=Code.js.map